import styled, { css } from "styled-components"
import { theme } from "Theme"

const btn = (bg, text) => css`
  white-space: nowrap;
  display: inline-block;
  border-radius: ${theme.borderRadius.elements};
  text-align: center;
  padding: 6px 18px;
  font-size: 14px;
  font-weight: bold;
  &:visited {
    color: white;
  }
  background: ${bg};
  color: ${text};
  border: 1px solid ${text};
  &:hover {
    background: ${text};
    &[disabled] {
      background: ${text};
    }
  }
  &:visited {
    color: black;
  }
  &[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const btnDefault = css`
  ${btn("#ffffff", "#888888")} color: #212121;
`

const btnPrimary = css`
  ${btn(theme.colors.primary.base, theme.colors.primary.base)} color: #ffffff;
`

const SimpleForm = styled.div`
  max-width: ${theme.breakpoints.s};
  color: inherit;
  margin: 0 auto;
  label {
    margin: 1rem 0 0;
    display: inline-block;
    text-align: center;
    width: 100%;
  }
  .error-message {
    margin: 0;
    display: inline-block;
    text-align: center;
    width: 100%;
    padding: 8px;
    margin: 8px 0;
    background: #f8d7da;
    color: #721c24;
    border-radius: ${theme.borderRadius.elements};
  }
  .AddonInput {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    margin: 1rem 0 0;
    @media (min-width: ${theme.breakpoints.s}) {
    }
    @media (min-width: ${theme.breakpoints.m}) {
      flex-direction: row;
    }
    @media (min-width: ${theme.breakpoints.l}) {
    }
    & > input {
      flex: 1;
      padding: 6px;
      font-size: ${theme.fontSize.smallish};
      color: #111;
      font-size: 12px;
      font-weight: bold;
      padding-left: 10px;
      line-height: initial;
      border-radius: ${theme.borderRadius.elements} 0 0 ${theme.borderRadius.elements};
      // margin: 1rem 0 0;
      @media (min-width: ${theme.breakpoints.s}) {
      }
      @media (min-width: ${theme.breakpoints.m}) {
        max-width: 100%;
      }
      @media (min-width: ${theme.breakpoints.l}) {
      }
    }
    & > button {
      // margin: 1rem 0 0;
      line-height: initial;
      height: 38px;
      &[type="submit"] {
        ${btnPrimary};
        border-radius: ${theme.borderRadius.elements};
      }
      &[type="button"] {
        ${btnDefault};
        border-radius: ${theme.borderRadius.elements};
      }
      @media (min-width: ${theme.breakpoints.m}) {
        &[type="submit"] {
          ${btnPrimary};
          border-radius: 0 ${theme.borderRadius.elements} ${theme.borderRadius.elements} 0;
          margin: 0;
        }
        &[type="button"] {
          ${btnDefault};
          border-radius: 0 ${theme.borderRadius.elements} ${theme.borderRadius.elements} 0;
          margin: 0;
        }
      }
    }
  }
`

export default SimpleForm
